<template>
  <div id="app" :class="utils.css_browser_selector(navigator.userAgent)">
    <div id="App-main">
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
import utils from "./utils";
export default {
  data() {
    return {
      utils: utils,
      navigator: navigator,
    };
  },
  mounted() {},
};
</script>

<style lang="scss">
#app {
  font-family: "OpenSans", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: $text-main;
}

html,
body {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
body {
  @media all and (max-width: $sm) {
    cursor: pointer;
  }
  margin: 0 auto;
  display: grid;
  width: 100%;
  overflow-x: hidden;
  position: relative;
  min-height: 100%;
  height: 100vh;
  overflow: hidden;
}
// .app-container {
//   height: auto !important;
//   overflow: auto !important;
// }
.stop-scrolling {
  height: 100vh;
  overflow: hidden;
  position: fixed;
  &.stop-scrolling-modal {
    @media all and (max-width: $md) {
      // height: unset;
      // overflow: unset;
      // overflow-x: hidden;
      // position: relative;
    }
  }
}

@font-face {
  font-family: "OpenSans";
  font-display: auto;
  font-style: normal;
  font-weight: bold;
  src: url("./assets/fonts/svg/OpenSans-Bold.svg") format("svg"),
    url("./assets/fonts/woff/OpenSans-Bold.woff") format("woff"),
    url("./assets/fonts/ttf/OpenSans-Bold.ttf") format("ttf");
}

@font-face {
  font-family: "OpenSans";
  font-display: auto;
  font-style: normal;
  font-weight: normal;
  src: url("./assets/fonts/svg/OpenSans-Regular.svg") format("svg"),
    url("./assets/fonts/woff/OpenSans-Regular.woff") format("woff"),
    url("./assets/fonts/ttf/OpenSans-Regular.ttf") format("ttf");
}

@font-face {
  font-family: "OpenSans";
  font-display: auto;
  font-style: normal;
  font-weight: 500;
  src: url("./assets/fonts/svg/OpenSans-Semibold.svg") format("svg"),
    url("./assets/fonts/woff/OpenSans-Semibold.woff") format("woff"),
    url("./assets/fonts/ttf/OpenSans-Semibold.ttf") format("ttf");
}
</style>
